import * as React from 'react';
import { ApiStore } from '../../stores/ApiStore';
import { inject } from '../../utils/decorators';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import { IRechnung, IRechnungListeResponse, IResponse } from '../../models/ApiTypes';
import { UiStore } from '../../stores/UiStore';
import { numberformatMoney } from '../../utils/numberformat';
import FaIcon from '../site/FaIcon';

/** Einzelnes Listenelement mit Kopfinformationen zu Rechnung/Gutschrift */
class AuftragBelegListItem extends React.Component<{rechnung: IRechnung}, {}> {

  @inject(UiStore) uiStore: UiStore;

  render() {
    const { rechnung } = this.props;
    return (
      <ListGroupItem
        onClick={() => this.uiStore.navigateTo(`/beleg/${rechnung.renr}`)}>
        <div>
          {rechnung.datum} - {rechnung.art} Nr. {rechnung.renr}
          {rechnung.netto && <span> - {numberformatMoney(rechnung.netto)} €</span>} - {rechnung.statustext}
          <span className="pull-right" title="Details zu diesem Beleg einsehen"><FaIcon icon="eye" /></span>
        </div>
      </ListGroupItem>
    );
  }
}

@observer
export default class AuftragBelegListe extends React.Component<{anr: string}, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @observable rechnungen: IRechnung[];

  @action setRechnungen(rechnungen: IRechnungListeResponse) {
    this.rechnungen = rechnungen;
  }

  async ladeRechnungen() {
    let response: IResponse<IRechnungListeResponse>;
    response = await this.apiStore.rechnungenAuftrag(this.props.anr);
    if (response && response.ok) {
      this.setRechnungen(response.json);
    }
  }

  componentDidMount() {
    this.ladeRechnungen();
  }

  render() {
    return (
      <div>
        <h3>Belege</h3>
        <Panel>
          <ListGroup fill={true} className="auftragsliste">
            {this.rechnungen && this.rechnungen.length === 0 && (<ListGroupItem>keine Einträge</ListGroupItem>)}
            {this.rechnungen && this.rechnungen.map((rechnung, index) => <AuftragBelegListItem key={index} rechnung={rechnung}/>)}
          </ListGroup>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/auftraege/AuftragBelegListe.tsx